import { useQuery } from "@tanstack/react-query";
import { getScheduleDashboardRuns, getReportScheduleRuns } from "../api";

export const useGetScheduleDashboardRuns = (options = {}, queryOptions = {}) => {
  const limit = options?.limit ?? 10;
  const year = options?.year;
  const month = options?.month;

  return useQuery({
    queryKey: ["schedule-dashboard-runs", limit, year, month],
    queryFn: () => getScheduleDashboardRuns({ limit, year, month }),
    ...queryOptions,
  });
};

export const useGetReportScheduleRuns = (reportId, year, month, scheduleId, options = {}) =>
  useQuery({
    queryKey: ["report-schedule-runs", reportId, year, month, scheduleId],
    queryFn: () => getReportScheduleRuns(reportId, { year, month, scheduleId }),
    enabled: !!reportId && !!year && !!month,
    ...options,
  });
